module.exports = __webpack_public_path__ + "media/images/soar/comments_clock1-3c76a793e5edb1f062d20ee72340ce2b.png";